import featuredPostsSlice from './featured-posts';
import ourNewsSlice from './our-news';
import publicationsSlice from './publications';
import selectedPostsSlice from './selected-posts';
import sliderHeroSlice from './slider-hero';
import twitterCarouselSlice from './twitter-carousel';
import videoHeroSlice from './video-hero';

const PRISMIC_TO_PARSER_SLICE = {
  sliderHero: sliderHeroSlice,
  ourNews: ourNewsSlice,
  featuredPosts: featuredPostsSlice,
  selectedPosts: selectedPostsSlice,
  twitterCarousel: twitterCarouselSlice,
  publications: publicationsSlice,
  videoHero: videoHeroSlice,
};

export default PRISMIC_TO_PARSER_SLICE;
